import { webTracker } from './tracker'
export const performance = () => {
    let performance = window.performance;
    let t = performance.timing;
    let timeList = {}

    // 页面加载完成时间：代表了用户等待页面可用的时间
    // let loadTime = t.loadEventEnd - t.navigationStart;
    let loadTime = t.loadEventEnd - t.fetchStart;
    timeList['loadTime'] = loadTime
    // 解析dom数时间
    // let domTime = t.domComplete - t.responseEnd;
    // timeList['domTime'] = domTime

    // 白屏时间
    // let whiteTime = t.domComplete - t.responseEnd;
    // timeList['whiteTime'] = whiteTime

    // 内容加载完成时间
    let contentLoadTime = t.domComplete - t.responseEnd;
    timeList['contentLoadTime'] = contentLoadTime

    // 总耗时
    let totalTime = (t.loadEventEnd || t.loadEventStart || t.domComplete || t.domLoading) - t.navigationStart; 
    timeList['totalTime'] = totalTime

    // TCP加载完成时间
    let TCPTime = t.connectEnd - t.connectStart;
    timeList['TCPTime'] = TCPTime

    // request请求耗时
    let requestTime = t.responseEnd - t.responseStart;
    timeList['requestTime'] = requestTime
    
    // 请求响应耗时
    let responseTime = t.responseStart - t.navigationStart;
    timeList['responseTime'] = responseTime

    let Logger = webTracker()
    Logger.push('performance', JSON.stringify(timeList));
    Logger.push('page_url', window.location.href);
    // console.log(timeList)
    Logger.logger()
}


// WEBPACK FOOTER //
// ./src/utils/performance.js